import React, { useState, useRef, useLayoutEffect } from 'react'
import i18n from 'i18next'
import Anchor from './Anchor'

import './styles/hoverInfo.scss'

const RIGHT_EDGE_MIN_MARGIN = 16 // from the right edge of viewport

function HoverInfo(props) {
    const {
        children, cssClass, title, desc, linkText, href, isExternal, target, dir,
    } = props

    const containerRef = useRef(null)
    const tooltipRef = useRef(null)
    const [adjustedDir, setAdjustedDir] = useState(dir || '')

    useLayoutEffect(() => {
        const checkPosition = () => {
            if (!containerRef.current || !tooltipRef.current) return

            const containerBoundary = containerRef.current.getBoundingClientRect()
            const tooltipWidth = tooltipRef.current.offsetWidth
            const viewportWidth = window.innerWidth
            const distanceFromRight = viewportWidth - containerBoundary.right

            const threshold = tooltipWidth - RIGHT_EDGE_MIN_MARGIN
            switch (dir) {
                case 'bottom':
                    if (distanceFromRight < threshold) setAdjustedDir('bottom-left')
                    break
                default:
                    setAdjustedDir(dir || '')
                    break
            }
        }
        window.addEventListener('resize', checkPosition)
        const container = containerRef.current
        if (container) {
            container.addEventListener('mouseenter', checkPosition)
            checkPosition()
        }

        return () => {
            if (container) container.removeEventListener('mouseenter', checkPosition)
            window.removeEventListener('resize', checkPosition)
        }
    }, [dir])

    return (
        <React.Fragment>
            <div className={`hover-info-container ${cssClass}`} ref={containerRef}>
                <div className="hover-info-target">
                    {children}
                </div>
                <div className={`hover-info-wrapper ${adjustedDir}`} ref={tooltipRef}>
                    {title && <p className="hover-title">{title}</p>}
                    <p className="hover-desc" dangerouslySetInnerHTML={{ __html: desc }} />
                    {href && (
                        <div className="link-wrapper">
                            <Anchor
                                cssClass="read-link"
                                href={href}
                                target={target || '_blank'}
                                isExternal={isExternal || true}
                            >
                                {linkText || i18n.t('read_more', 'Read more')}
                                <i className="fa-sharp fa-regular fa-arrow-right" />
                            </Anchor>
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>
    )
}

export default HoverInfo
